module.exports = __webpack_public_path__ + "assets/img/MIBBLogo.6e7d780f.png";